import React from 'react';

const RaceCounter = ({ current = 3, total = 5, status = "IN PROGRESS" }) => {
  return (
    <div className="instrument-widget counter-widget">
      <div className="counter-display">
        <span className="current-num">{current}</span>
        <span className="separator">/</span>
        <span className="total-num">{total}</span>
      </div>
      <div className="counter-label">RACE</div>
      <div className="status-tag">{status}</div>
    </div>
  );
};

export default RaceCounter;
